/**
 * This project's binding of the kit's action layer (#1798).
 *
 * `createActionLayer` is generic; binding it HERE is what closes the three
 * unions the declarations are checked against — the registered menu sections,
 * the backend permission catalogue, and this app's view payload. Declaration
 * sites then just call `defineActions(model, { … })`.
 */
import type { ReactElement, ReactNode } from 'react';
import { createActionLayer } from '@resource-kit/core';
import type { PermissionKey } from '@/permissions';
import type { MenuSection } from './menu-sections';

/**
 * What a derived route renders, kept behind a thunk so the action layer stays a
 * plain data structure: elements are built when the router mounts the route, not
 * when the catalogue module is evaluated.
 */
export interface ActionView {
  render: () => ReactElement;
}

export const defineActions = createActionLayer<MenuSection, PermissionKey, ReactNode, ActionView>();
